import axiosInstance from "../../config/axiosInstance";

const deleteUserRequest = async id => {
  const response = await axiosInstance.dillApi().delete("/admin/users/" + id);
  return response;
};

export default deleteUserRequest;
